var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhotoGallery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_624_1506)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.15 7.13997L9.43999 8.94997L6.18999 4.96997L1.48999 8.94997V13.46H16.13V10.75V8.94997L12.15 7.13997Z",
    fill: "#444444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.72 4.42989C13.4214 4.42989 13.99 3.86129 13.99 3.15989C13.99 2.45849 13.4214 1.88989 12.72 1.88989C12.0185 1.88989 11.45 2.45849 11.45 3.15989C11.45 3.86129 12.0185 4.42989 12.72 4.42989Z",
    fill: "#444444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.62 15H0V0H17.62V15ZM0.9 14.1H16.71V0.9H0.9V14.1Z",
    fill: "#444444"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_624_1506"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoGallery);
export default __webpack_public_path__ + "static/media/PhotoGallery.f74c0c9096c47973b3a36c49fd0c4727.svg";
export { ForwardRef as ReactComponent };